import {notNull} from '../../../../../../library/clxProductNet/assets/js/modules/common/assert';
import {debounce} from '../../common/debounce';

export default class RecombeeSearch {
    private recombeeInput: HTMLInputElement;

    private searchResultContainer: HTMLDivElement;

    private readonly searchUrl: string;

    constructor() {
        this.recombeeInput = notNull(document.getElementById('recombee_input')) as HTMLInputElement;
        this.searchResultContainer = notNull(document.getElementById('recombee_search_result')) as HTMLDivElement;
        this.searchUrl = document.querySelector('ul#ajax-urls li#ajax-autocomplete-fulltextsearch')!.textContent!.trim();

        this._attachSearchListener();
    }

    private _attachSearchListener() {
        this.recombeeInput.addEventListener(
            'keyup',
            debounce(() => {
                this.recombeeSearch();
            }, 500),
        );
    }

    async recombeeSearch() {
        // start searching if more than 2 characters
        if (this.recombeeInput.value.length > 2) {
            // @ts-ignore
            if (window.ga) {
                // @ts-ignore
                ga('send', 'pageview', '/suche?q=' + this.recombeeInput.value);
            }
            const request = await fetch(this.searchUrl + 'searchterm/' + this.recombeeInput.value, {
                method: 'GET',
                headers: {'X-Requested-With': 'XMLHttpRequest'},
            });

            if (!request.ok) {
                return;
            }

            this._showResult();
            this.searchResultContainer.innerHTML = await request.text();
        }
    }

    private _showResult() {
        let overBox: HTMLDivElement | null = document.querySelector('.overlay');
        const HTMLbody: HTMLBodyElement = notNull(document.querySelector('body')) as HTMLBodyElement;

        if (!overBox) {
            overBox = document.createElement('div');
            overBox.classList.add('overlay');
            document.body.appendChild(overBox);
            document.body.style.overflow = 'hidden';
            HTMLbody.style.overflow = 'hidden';
            overBox.addEventListener('click', () => {
                HTMLbody.removeAttribute('style');
                document.body.removeAttribute('style');
                this.searchResultContainer.innerHTML = '';
            });
        }

        // the orderform_hint element exists on the mobile page only
        const orderFormHint: HTMLDivElement | null = document.getElementById('orderform_hint') as HTMLDivElement;
        if (orderFormHint) {
            this.searchResultContainer.removeAttribute('style');
            orderFormHint.style.display = 'none';
            const recombeeSearchClose = document.querySelector('#recombee_search a.nav-close');
            recombeeSearchClose?.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                document.querySelector('div.overlay')?.remove();
                this.recombeeInput.value = '';
                this.searchResultContainer.innerHTML = '';
                orderFormHint.style.display = 'block';
            });
        }
    }
}
